export default __webpack_public_path__ + "static/media/image.31e66434.svg";